import { Flex, Text, Button, ModalContext } from 'dash-ui';
import { useTheme } from 'styled-components';

import {
  ActionsWrapper,
  AmenityImage,
  AmenityItemWrapper,
  AmenityNameWrapper,
} from './AmenityItem.styles';
import { IAmenityItem } from './AmenityItem.interfaces';
import { useContext } from 'react';

const AmenityItem = ({ amenity, onAmenityEditClick }: IAmenityItem) => {
  const theme = useTheme();
  const { toggleModal, setPayload } = useContext(ModalContext);

  return (
    <AmenityItemWrapper
      data-testid="amenity-item"
      minWidth={230}
      h="100%"
      pb={2}
      pt={8}
      justifyContent="center"
      alignItems="center"
    >
      <Flex flexDirection="column" alignItems="center">
        <AmenityImage
          fit="scale-down"
          size={64}
          src={amenity.imageUrl || ''}
          alt={amenity.name}
        />
        <AmenityNameWrapper w={174}>
          <Text color={theme.colors.n80}>{amenity.name}</Text>
        </AmenityNameWrapper>
      </Flex>
      <ActionsWrapper>
        <Button m={1} icon="edit" square onClick={onAmenityEditClick} />
        <Button
          variation="primary"
          m={1}
          icon="trash"
          square
          onClick={() => {
            setPayload(amenity);
            toggleModal(true, 'DeleteAmenityModal');
          }}
        />
      </ActionsWrapper>
    </AmenityItemWrapper>
  );
};

export default AmenityItem;
